import React from "react";
import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import { Tooltip } from "@material-ui/core";
import classnames from "classnames";

function HistoryButton({
    e,
    isEdited,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setRowData,
    setSelectedRows,
    isLoading,
    oneShop,
    t,
    setModalState,
}: any) {
    const handleHistoryClick = ({
        isEdited,
        setIsActionsClicked,
        setActions,
        setRowData,
        setSelectedRows,
        selectedRow,
        setIsEdited,
    }: any) => {
        if (isEdited) {
            setIsActionsClicked((prev: any) => !prev);
            setActions(() => {
                setModalState((prev: any) => ({
                    ...prev,
                    isAddModeOfSaleClicked: false,
                }));
                setModalState((prev: any) => ({
                    ...prev,
                    isHistoryModalOpened: true,
                }));
                setRowData(selectedRow);
                setSelectedRows([selectedRow]);
                setIsEdited(false);
            });
        } else {
            setModalState((prev: any) => ({
                ...prev,
                isHistoryModalOpened: true,
            }));
            setRowData(selectedRow);
            setSelectedRows([selectedRow]);
        }
    };

    return (
        <Tooltip title={t("Consult history")}>
            <div>
                <TimePastSvgIcon
                    onClick={() =>
                        handleHistoryClick({
                            isEdited,
                            setIsActionsClicked,
                            setActions,
                            setRowData,
                            setSelectedRows,
                            selectedRow: e.selectedRow,
                            setIsEdited,
                        })
                    }
                    className={classnames(
                        "pointer__clz  cmn_icn_FRhistory",
                        oneShop ? "mr-2" : "ml-3",
                        {
                            "not-allowed-icon__clz": isLoading,
                        }
                    )}
                />
            </div>
        </Tooltip>
    );
}

export default HistoryButton;
